import type { SentryMetricCounter } from "@remi/enums/sentry-metric-counter";
import type { SentryMetricDistribution } from "@remi/enums/sentry-metric-distribution";
import type { SentryMetricGauge } from "@remi/enums/sentry-metric-gauge";

type Maybe<T> = null | undefined | T;
export interface RemiErrorDeprecatedExtensionOptions {
  [attributeName: string]: unknown;
}
interface RemiErrorDeprecatedOptions {
  pkg?: Maybe<string>;
  path?: Maybe<string>;
  attributes?: Maybe<RemiErrorDeprecatedExtensionOptions>;
}
export interface RemiErrorDeprecatedInput {
  message: string;
  originalError?: Maybe<Error>;
  options?: RemiErrorDeprecatedOptions;
}

export type SentryErrorMetric =
  | {
      type: "counter";
      value?: number;
      name: SentryMetricCounter;
      attributes?: Record<string, unknown>;
    }
  | {
      type: "gauge";
      value: number;
      name: SentryMetricGauge;
      attributes?: Record<string, unknown>;
    }
  | {
      type: "distribution";
      value: number;
      name: SentryMetricDistribution;
      attributes?: Record<string, unknown>;
    };

export const DEFAULT_ERROR_NAME = "RemiErrorDeprecated";
export const ERROR_SENTRY_DATA_PROPERTY = "__sentryData";
